<div class="new-analysis">
	<ng-container *ngIf="!isPortfoliosLoading; else loading">
		<div *ngIf="savedPortfolios.length; else emptyMessage">
			<div class="modal-content">
				<portfolio-table
					[maxLimit]="maximumPortfoliosToSelect"
					[maxChildrenLimit]="maximumChildrenLimit" 
					[(allPortfolios)]="savedPortfolios"
					[(selectedPortfolios)]="selectedPortfolios"
					[enableFilterByPortfolioType]="enableFilterByPortfolioType"
					[searchPlaceholder]="'Search by keyword'"
					[isPartiallyLoading]="isPartnerPortfoliosLoading"
					[partialLoadingMessage]="partnerPortfoliosLoadingMessage"
					[showCreateNewPortfolioButton]="showCreateNewPortfolioButton"
					[enableDeselectAll]="enableDeselectAll"
					(isPortfolioEditorVisible)="openCreateNewPortfolio()"
					(isMaxChildLimitReached)="checkChildrenValidity($event)"
				>
				</portfolio-table>
			</div>
		</div>
	</ng-container>
	<ng-template #emptyMessage>
		<div class="no-portfolios-saved">
			<p dcrHTMLKey="NO_SAVED_PORTFOLIOS">You have no saved or subscribed portfolios yet</p>
			<div class="padding-top-30">
				<a class="cta-create-portfolio hover-underline" (click)="openCreateNewPortfolio()">
					<icon type="plus"></icon> <span class="text-16-bold" dcrHTMLKey="CREATE_NEW_PORTFOLIO">Create new portfolio</span>
				</a>
			</div>
		</div>
	</ng-template>
	<ng-template #loading>
		<div class="modal-content">
			<portfolio-table-skeleton [isFullScreenList]="false"></portfolio-table-skeleton>
		</div>
	</ng-template>
</div>
